import '@/styles/index.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { Toaster, TooltipProvider } from '@/components/ui'
import { clearChunkReloadFlag } from '@/features/errors/chunk'
import { initAnalytics } from '@/lib/analytics'
import { I18nProvider, initI18n } from '@/lib/i18n'
import { registerServiceWorker } from '@/lib/pwa'
import { queryClient } from '@/lib/queryClient'
import { installGlobalRealtimeHandlers } from '@/lib/realtime'
import { initTheme } from '@/lib/theme'
import { router } from '@/router'

// Before the first render: theme (index.html already painted it), realtime handlers, analytics.
initTheme()
installGlobalRealtimeHandlers(queryClient)
void initAnalytics()

async function boot(): Promise<void> {
  // Loads the saved language dictionary first so the first paint is already translated.
  await initI18n()
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={300}>
          <I18nProvider>
            <RouterProvider router={router} />
          </I18nProvider>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
  void registerServiceWorker()
  // A healthy boot re-arms the one time reload for stale chunks after the next deploy.
  setTimeout(clearChunkReloadFlag, 10_000)
}

void boot()
